const To = ({ message }) => {
  return (
    <div className=" mb-3 justify-content-end ">
      <div className="ps-5">
        <div className="bg-cl-azure align-items-center px-3 py-2" style={{ borderRadius: "20px" }}>
          <span className="text-white fz-12 ff-univanova text-wrap">{message.message}</span>
        </div>
      </div>
      {/* <div className="col-1 btn-group">
        <button
          type="button"
          className="btn dropdown-toggle p-0"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="bi bi-three-dots-vertical"></i>
        </button>
        <ul className="dropdown-menu" style={{ borderRadius: "10px" }}>
          <li>
            <span
              className="dropdown-item fz-14 ff-univanova-regular c-pointer  text-cl-black"
              data-bs-toggle="modal"
              data-bs-target="#myModalSingle"
            >
              Editar
            </span>
          </li>
          <li>
            <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer  text-cl-red">
              Excluir
            </span>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default To;
